<app-title-content-widget [title]="title" [widgetPanel]="widgetPanel">
  <ng-template #titleContentPanel>
    <div class="col g-0">
      <div class="inner-panel">
        <div class="panel-row row">
          @for (widgetPanelChart of widgetPanelCharts; track widgetPanelChart) {
            <div
              [ngClass]="{
                'col-3': widgetPanelCharts.length > 1,
                'col-12': widgetPanelCharts.length === 1
              }"
            >
              @if (!widgetPanelChart.noDataMessage) {
                <div>
                  <app-charts
                    [chartId]="widgetPanelChart.data.chartTitle"
                    [chartTitle]="widgetPanelChart.data.chartTitle"
                    [chartData]="widgetPanelChart.data.chartData"
                    [chartType]="widgetPanelChart.data.chartType"
                    [chartPlugins]="widgetPanelChart.data.chartPlugins"
                    [chartOptions]="widgetPanelChart.data.chartOptions"
                    [displayChartTitle]="
                      widgetPanelChart.data.displayChartTitle
                    "
                    [ngStyle]="widgetPanelChart.data.chartStyle"
                  ></app-charts>
                </div>
              }
              @if (widgetPanelChart.noDataMessage) {
                <div class="centered">
                  <label>{{ widgetPanelChart.noDataMessage }}</label>
                </div>
              }
            </div>
          }
        </div>
        <ng-content></ng-content>
      </div>
    </div>
  </ng-template>
</app-title-content-widget>
